import { useEffect, useId, useRef, useState } from 'react';
import { useFocusTrap } from '@amo/core/utils/hooks';
import './modal.scss'

export const Modal = (props) => {
    const { title = '', classTitle = '', children, canClose = true, bodyScrollable = false, large = false, onClick } = props
    const [close, setClose] = useState(false)
    const dialogRef = useRef(null);
    const reactId = useId();
    const titleId = title ? `modal-title-${reactId.replace(/:/g, '')}` : undefined;

    const handleClose = onClick ? onClick : () => setClose(true);

    useFocusTrap(dialogRef, { onEscape: canClose ? handleClose : undefined });

    useEffect(() => {
        if (!bodyScrollable && !close) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }
        return () => {
            document.body.classList.remove('modal-open');
        };
    }, [bodyScrollable, close]);

    if (close) return null;

    return (
        <div data-id="modal">
            <div
                className={`modal fade show d-block`}
                role="dialog"
                aria-modal="true"
                aria-labelledby={titleId}
                ref={dialogRef}
            >
                <div className={`modal-dialog modal-dialog-scrollable ${large && 'modal-lg'}`} role="document">
                    <div className="modal-content">

                        {
                            ( canClose || title ) &&

                                <div className="modal-header">
                                    {title && <h2 id={titleId} className={`${classTitle} modal-title h5`} data-test={'title'} dangerouslySetInnerHTML={{__html: title}} />}

                                    { canClose &&
                                        <button type="button" className="btn-close" data-dismiss="modal" aria-label="Fermer la fenêtre" onClick={handleClose} data-test={"close"}></button>
                                    }
                                </div>
                        }
                        <div className="modal-body">
                            { children }
                        </div>
                    </div>
                </div>
            </div>

            { !bodyScrollable && <div data-test={"background"} className={`modal-backdrop show d-block`} /> }
        </div>
    );
};

